<template>
    <div class="orb-business-panel">
    <div class="border">

      <div class="header">
        <div class="header-text">
          <div class="pt-kicker">业务面板</div>
          <p class="card-title">{{ title }}</p>
        </div>
        <button class="close" @click="closeClick">&times;</button>
      </div>

      <!-- 主体内容 -->
      <div class="content-body">

        <!-- 设备运行状态 -->
        <div class="section-title">关键设备运行状态</div>
        <table class="data-table">
          <tr>
            <th>设备名称</th>
            <th>运行状态</th>
            <th>当前功率</th>
            <th>温度</th>
            <th>负责人</th>
          </tr>
          <tr v-for="dev in devices" :key="dev.name">
            <td>{{ dev.name }}</td>
            <td :class="dev.statusClass">{{ dev.status }}</td>
            <td>{{ dev.power }} kW</td>
            <td>{{ dev.temp }} ℃</td>
            <td>{{ dev.person }}</td>
          </tr>
        </table>

        <!-- 巡检记录 -->
        <div class="section-title">巡检记录</div>
        <ul class="check-list">
          <li v-for="item in inspections" :key="item.date">
            <span class="check-date">{{ item.date }}</span>
            <span class="check-content">{{ item.content }}</span>
            <span :class="['check-status', item.levelClass]">{{ item.level }}</span>
          </li>
        </ul>

        <!-- 运维工单 -->
        <div class="section-title">维护工单</div>
        <table class="data-table">
          <tr>
            <th>工单号</th>
            <th>问题描述</th>
            <th>创建时间</th>
            <th>处理人</th>
            <th>状态</th>
          </tr>
          <tr v-for="order in workOrders" :key="order.id">
            <td>{{ order.id }}</td>
            <td>{{ order.desc }}</td>
            <td>{{ order.time }}</td>
            <td>{{ order.person }}</td>
            <td :class="order.statusClass">{{ order.status }}</td>
          </tr>
        </table>

        <!-- 设备寿命评估 -->
        <div class="section-title">设备寿命评估</div>
        <table class="data-table">
          <tr>
            <th>设备名称</th>
            <th>已使用年份</th>
            <th>预计剩余寿命</th>
            <th>建议措施</th>
          </tr>
          <tr v-for="life in lifespan" :key="life.name">
            <td>{{ life.name }}</td>
            <td>{{ life.used }} 年</td>
            <td>{{ life.left }} 年</td>
            <td>{{ life.advice }}</td>
          </tr>
        </table>

        <!-- 故障记录 -->
        <div class="section-title">近期故障记录</div>
        <ul class="fault-list">
          <li v-for="f in faults" :key="f.time">
            <span class="fault-time">{{ f.time }}</span>
            <span class="fault-msg">{{ f.msg }}</span>
            <span class="fault-solve">{{ f.resolve }}</span>
          </li>
        </ul>

        <!-- 运维值班表 -->
        <div class="section-title">值班人员安排</div>
        <table class="data-table">
          <tr>
            <th>日期</th>
            <th>负责人</th>
            <th>班次</th>
            <th>联系电话</th>
          </tr>
          <tr v-for="p in duty" :key="p.date">
            <td>{{ p.date }}</td>
            <td>{{ p.person }}</td>
            <td>{{ p.shift }}</td>
            <td>{{ p.phone }}</td>
          </tr>
        </table>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "operationMaintenance",
  data() {
    return {
      title:"工程运维管理",
      devices: [
        { name: "1号高压泵", status: "运行正常", statusClass: "green", power: 320, temp: 42, person: "李浩" },
        { name: "2号高压泵", status: "待机", statusClass: "blue", power: 0, temp: 29, person: "李浩" },
        { name: "变频控制柜", status: "温度偏高", statusClass: "yellow", power: 18, temp: 58, person: "赵工" }
      ],

      inspections: [
        { date: "2025-02-10", content: "泵站内无异常振动，温度正常", level: "正常", levelClass: "green" },
        { date: "2025-02-08", content: "输水管线阀室发现轻微渗水", level: "需关注", levelClass: "yellow" },
        { date: "2025-02-06", content: "机房电柜清洁完毕", level: "正常", levelClass: "green" }
      ],

      workOrders: [
        { id: "WO-20240201", desc: "3号泵噪音偏大", time: "2025-02-05", person: "刘师傅", status: "处理中", statusClass: "yellow" },
        { id: "WO-20240112", desc: "阀室照明损坏", time: "2025-01-18", person: "韩工", status: "已完成", statusClass: "green" },
        { id: "WO-20240108", desc: "控制柜温度报警", time: "2025-01-10", person: "赵工", status: "已关闭", statusClass: "blue" }
      ],

      lifespan: [
        { name: "离心泵 1号", used: 4, left: 6, advice: "正常使用" },
        { name: "输水管线南段", used: 8, left: 12, advice: "定期检测壁厚" },
        { name: "变频柜", used: 6, left: 3, advice: "需关注散热状态" }
      ],

      faults: [
        { time: "2025-01-28 14:22", msg: "泵站 A 房电压短时波动", resolve: "自动恢复" },
        { time: "2025-01-20 09:10", msg: "监测终端掉线", resolve: "已重启修复" }
      ],

      duty: [
        { date: "2025-02-10", person: "王平", shift: "白班", phone: "138-1111-2222" },
        { date: "2025-02-10", person: "陈亮", shift: "夜班", phone: "139-3333-4444" },
        { date: "2025-02-11", person: "李伟", shift: "白班", phone: "136-7777-9999" }
      ]
    };
  },
  methods: {
    closeClick() {
      this.$emit("infoClose");
    }
  }
};
</script>

<style scoped>

.border {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border-radius: 10px;
  margin-top: 0;
  padding: 18px;
  box-sizing: border-box;
  color: #eef7ff;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(99, 179, 237, 0.28);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}
.header-text {
  flex: 1;
}
.card-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.orb-business-panel {
  width: min(1040px, calc(100vw - 230px));
  height: calc(100vh - 150px);
  position: absolute;
  left: 50%;
  top: 112px;
  transform: translateX(-54%);
  z-index: 9998;
}


.content-body {
  color: #fff;
  font-size: 14px;
  padding: 10px 20px;
  height: calc(100% - 60px); /* 避免撑出 .border 区域，数值可依情况微调 */
  overflow-y: auto;
}

.section-title {
  font-size: 14px;
  margin-top: 16px;
  color: #fff;
  border-left: 4px solid rgba(56, 189, 248, 0.48);
  padding-left: 8px;
  font-weight: 700;
}

.data-table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
  color: #fff;
}
.data-table th {
  background: rgba(56, 189, 248, 0.1);
  padding: 8px;
  border: 1px solid rgba(255,255,255,0.08);
  color: #b8ecff;
  font-weight: 600;
}
.data-table td {
  padding: 8px;
  border: 1px solid rgba(255,255,255,0.04);
  color: rgba(255, 255, 255, 0.72);
}

.green { color: #00ff9c; }
.blue { color: #00c3ff; }
.yellow { color: #ffd000; }

.check-list li, .fault-list li {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}

.check-date, .fault-time {
  color: #ccc;
  width: 120px;
}

.fault-msg {
  flex: 1;
  margin-left: 10px;
}

.fault-solve {
  color: #76d9ff;
  width: 140px;
  text-align: right;
}

.close {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s;
}
.close:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}
</style>
